"use strict";

class StationSettingsRadioDNSCtrl
{
    constructor($rootScope, $http, $mdToast, $scope, $mdDialog)
    {
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;

        this.custom_radiovis_fqdn = false;

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        this.strings = [];
        this.visuals = [];

        $scope.$watch(() => {
            return $scope.radiodnsform.$invalid;
        },(newVal) => {
            $rootScope.saveDisabled = newVal;
        });

        this.exportData = {
            radiodns: {}
        };

        $rootScope.saveSettings = () => {
            this.save();
        };

        this.fetch();
    }

    fetch()
    {
        this.$http.get('/stationsettings/export/radiodns').then(response => {

            this.exportData = response.data;

            if (this.exportData.radiodns.radiovis_fqdn){
                if (this.exportData.radiodns.radiovis_fqdn != "radiovis.radiomanager.pluxbox.com"){
                    this.custom_radiovis_fqdn = true;
                }
            } else {
                this.exportData.radiodns.radiovis_port = "61613";
            }
        });

        this.$http.get('/station/strings').then(response => {
            this.strings = response.data;
        });

        this.$http.get('/station/visuals').then(response => {
            this.visuals = response.data;
        });

    }

    save()
    {
        this.$rootScope.buttonDisabled = true;

        if(!this.exportData.radiodns.radiovis_fqdn){
            this.exportData.radiodns.radiovis_fqdn = "radiovis.radiomanager.pluxbox.com";
        }

        this.$http.put('/stationsettings/export', this.exportData).then(() => {

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=RadioDNS', //@trans('labels.Export')
                hideDelay: 6000,
                position: ('top right')
            });

            this.$rootScope.buttonDisabled = false;
        });
    }

    toggleRadiovisDefault() {
        if (!this.custom_radiovis_fqdn){
            this.exportData.radiodns.radiovis_port = "61613";
        }
    }
    toggleRadiotagDefault() {
        this.exportData.radiodns.radiotag_port = "80";
    }

    saveOne(name, key, data) {
        this.$rootScope.saveDisabled = true;
        data.last = new Date();

        let list = {};
        list[key] = data;
        this.$http.put('/stationsettings/export', list).then(() => {

            if(key != 'radiodns') {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.object_saved?object='+name,
                    //@trans('labels.vTuner') @trans('labels.RadioDNS') @trans('labels.TuneIn')
                    //@trans('labels.DarFM') @trans('labels.Radioline')
                    hideDelay: 6000,
                    position: ('top right')
                });
            }
            this.$rootScope.buttonDisabled = false;
        });
    }

    requestRadioDNS(name) {

        this.saveOne(name, 'radiodns', this.exportData.radiodns);

        this.$http.post("organisation/radiodns_confirm_request").then((response) => {
            if(response.data.error) {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.error?title='+response.data.error,//@trans('labels.Organisation_email_not_found')
                    hideDelay: 6000,
                    position: ('top right')
                });
            } else {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.object_saved?object='+name,
                    hideDelay: 6000,
                    position: ('top right')
                });
            }
        });
    }


    radioDNSDialog() {
        this.$mdDialog.show({
            controller: 'RadioDNSDialogCtrl',
            templateUrl: "RequestRadioDNS.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            escapeToClose: false,

        })
        .then(() => {})
        .then(() => {});
    }
    
}

StationSettingsRadioDNSCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$scope', '$mdDialog'];

module.exports = StationSettingsRadioDNSCtrl;
